/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React, { useEffect, useState } from "react";  // Import React and hooks for component functionality
import CustomTh from "../../../../../components/table/CustomTh";  // Import table header component
import CustomTd from "../../../../../components/table/CustomTd";  // Import table cell component
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";  // Import dropdown menu component for actions
import { useDispatch, useSelector } from "react-redux";  // Import hooks for dispatching actions and accessing state from Redux
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";  // Import dropdown menu item component
import DownloadIcon from "@mui/icons-material/Download";  // Import download icon from Material-UI
import { URL } from "../../../../../Apis/Constants";  // Import URL constants
import notify1 from "../../../../../assets/images/notify1.png";  // Import various notification icons
import notify2 from "../../../../../assets/images/notify2.svg";
import notify3 from "../../../../../assets/images/notify3.png";
import notify4 from "../../../../../assets/images/notify4.png";
import notify5 from "../../../../../assets/images/notify5.png";
import packageImg from "../../../../../assets/images/package.png";  // Import default package image
import {
    GetListAnnouncements
} from "../../../../../reduxToolkit/Announcement/AnnouncementApi";  // Import API call to fetch announcements
import { getDateFormat, getImageByExt, getToken } from "../../../../../Apis/functions";  // Import utility functions for date formatting, image handling, and token fetching
import CustomImageTable from "../../../../../components/CustomImageTable";  // Import custom image table component
import TableFunction from "../../../../../components/table/TableFunction";
import {LEFT_FIRST_COLUMN_WITH_CHECKBOX} from "../../../../../components/table/Model/TableModel";  // Import table function hook for pagination, etc.

const NotificationTableApp = ({selectedList, setSelectedList, modified, setModified, setExpandImage, setIsAllChecked }) => {
    // Dispatch and selector for handling Redux state
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);  // Select development flag from Redux state
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);  // Select permission data from Redux state
    const results = useSelector((state) => state?.AnnouncementSlice?.getListAnnouncements);  // Get announcements from Redux state
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    // Local state for handling table ID, search ID, and date
    const tableId = "tbl_nta_events";
    const searchId = "txt_nta_events";
    const leftPosition = LEFT_FIRST_COLUMN_WITH_CHECKBOX;

    // Create date object for today's date + 5 days (for filtering purposes)
    var today = new Date();
    today.setDate(today.getDate() + 5);
    let time_in_miliseconds = today.getTime();

    // Table headers for announcements
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head">{t('title')}</CustomTh>,  // Column for title
            <CustomTh tableId={tableId}>{t('type')}</CustomTh>,  // Column for type
            <CustomTh tableId={tableId}>{t('description')}</CustomTh>,  // Column for description
            <CustomTh tableId={tableId}>{t('meeting_date')}</CustomTh>,  // Column for meeting date
            <CustomTh tableId={tableId}>{t('file')}</CustomTh>,  // Column for file attachment
            <CustomTh tableId={tableId}>{t('created_at')}</CustomTh>,  // Column for creation date
            <CustomTh tableId={tableId}>{t('created_by')}</CustomTh>  // Column for the creator's name
        ];
    };

    // Table body that dynamically populates based on fetched results
    const getTbody = () => {
        if (!results || results?.content?.length === 0) return { body: [], data: [] };  // If no results, return empty table

        let body = results?.content?.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={"first-column"}>{item?.title}</CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomImageTable
                            text={item?.announcementType ? item.announcementType.id === 4 ? item.type : item.announcementType.name : ''}
                            image={getNotificationIcon(item)}  // Display the appropriate notification icon
                            containerClass={"d-flex"}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>{item?.message}</CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.announcementType && item.announcementType.id === 2 ? getDateFormat(item.createdAt) : '--'}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.path !== 'none' ? (
                            item?.path.split('_')[1] === 'file' ? (
                                <CustomImageTable text={""} image={getImageByExt(item?.path?.split('.').pop())} />
                            ) : (
                                <CustomImageTable
                                    text={""}
                                    image={`data:image/${item?.path.split('.')[1]};base64,${item?.image}`}
                                    buttonImg={"btn_nta_expand_image_" + index}
                                    click={(e, image) => { setExpandImage(image); }}  // Handle image expansion click
                                />
                            )
                        ) : "--"}
                    </CustomTd>
                    <CustomTd tableId={tableId}>{getDateFormat(item.createdAt, true)}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.user?.name}</CustomTd>
                </>
            );
        });

        return { body: body, data: results?.content };  // Return table body and data
    };

    // Function to return notification icon based on notification type
    const getNotificationIcon = (item) => {
        if (item?.notificationType) {
            if (item.notificationType.id === 1) return notify1;
            else if (item.notificationType.id === 2) return notify2;
            else if (item.notificationType.id === 3) return notify3;
            else if (item.notificationType.id === 4) return notify4;
            else if (item.notificationType.id === 5) return notify5;
        }
        return packageImg;  // Default image
    }

    // Render action buttons for each event (e.g., for downloading files/images)
    const getActionsButtons = (item, index) => {
        return (
            <>
                {item?.path !== 'none' ? (
                    <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                        <DropDownMenuItem
                            id={"btn_nta_download_"+ item.id}
                            index={index}
                            handleClose={handleClose}
                            name={t('download')}
                            icon={<DownloadIcon fontSize='small' />}
                            click={() => {
                                if (item?.path.split('_')[1] === 'file') handleDownloadFile(item);
                                else handleDownloadImage(item);
                            }}
                        />
                    </DropDownMenuProfile>
                ) : "--"}
            </>
        );
    };

    // Table function hook to handle pagination, selection, and table actions
    const { t, thead, tbody, handleCheckboxChange, openMenu, handleMenuToggle, handleClose, pagination, handleDeleteAll, page, rowsPerPage } = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        getThead,
        getTbody,
        labelRowsPerPage: 'announcements_per_page',
        setIsAllChecked
    });

    // Download file handler (fetch and download file)
    const handleDownloadFile = (item) => {
        fetch(`${URL}image-service/download-by-id/${item?.id}/option/announcement_file`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
                Authorization: `Bearer ${getToken()}`,
            },
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${item?.path}`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            });
    };

    // Download image handler (fetch and download image)
    const handleDownloadImage = (item) => {
        fetch(`${URL}image-service/download-by-id/${item.id}/option/announcement_image`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/png',
                Authorization: 'Bearer ' + getToken(),
            },
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${item.path}`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            });
    };

    // Fetch data whenever pagination or modification changes
    useEffect(() => {
        getData();
    }, [page, rowsPerPage]);

    // Fetch data if there are any changes in modifications
    useEffect(() => {
        if (modified) {
            getData();
            setModified(false);
        }
    }, [modified]);

    // Function to get announcement data with pagination
    const getData = () => {
        let body =  {
            date: time_in_miliseconds,
            pagination: {
                order: true,
                page: page,
                size: rowsPerPage,
                sortBy: 'id',
            },
        };
        dispatch(GetListAnnouncements(body));  // Dispatch API call
    }

    // Return props to be used in parent component
    return {
        DEV,
        permission,
        contractorId,
        supplierId,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        pagination
    };
}

export default NotificationTableApp;
